import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';

import { useHeader, withWidget } from '@ezbobdev/ui-commons';
import { MainContext, t } from '@ezbobdev/ui-framework';
import { Tools } from '@ezbobdev/ui-sdk';
import { LoginIcon, LogoutIcon } from '@ezbobdev/ui-widgets-ezbob';

import { MaterialButtonStyled } from './LogoutButton.styled';

const LogoutButton = (props) => {
  const { history } = props;

  const { actions } = useContext(MainContext);
  const { logout, login } = useHeader(props, 'MaterialAppBar');

  const authorities = actions.userState.getUserState('authorities');
  const customerWizardUrl = actions.settings.getPageRoute('customerWizard').url;
  const allowSignUp = actions.settings.getUserConfigProp('system.allowSignup');
  const useIconButtons = actions.settings.getUserConfigProp('widgetsConfig.materialAppBar.useIconButtons');

  // On broker mode don't display any button
  if (authorities.includes('ROLE_BROKER')) return undefined;

  const userData = Tools.getOption('userData');

  if (window.location.pathname === customerWizardUrl) {
    return userData ? (
      <MaterialButtonStyled
        variant="text"
        color="inherit"
        className="logout"
        title={userData.username}
        onClick={logout}
        data-testid="logout-button"
        aria-label={t(`header.logout`)}
        $isIconButton={useIconButtons}
      >
        {useIconButtons ? <LogoutIcon /> : t(`header.logout`)}
      </MaterialButtonStyled>
    ) : (
      <MaterialButtonStyled
        variant="text"
        color="inherit"
        className="login"
        onClick={login}
        data-testid="login-button"
        aria-label={t(`header.login`)}
        $isIconButton={useIconButtons}
      >
        {useIconButtons ? <LoginIcon /> : t(`header.login`)}
      </MaterialButtonStyled>
    );
  } else {
    if (userData) {
      return (
        <MaterialButtonStyled
          variant="text"
          color="inherit"
          className="logout"
          title={userData.username}
          onClick={logout}
          $isIconButton={useIconButtons}
        >
          {useIconButtons ? <LogoutIcon /> : t(`header.logout`)}
        </MaterialButtonStyled>
      );
    } else if (allowSignUp) {
      return (
        <MaterialButtonStyled
          className="signup"
          color="inherit"
          variant="text"
          onClick={() => history.push(customerWizardUrl)}
          $isIconButton={useIconButtons}
        >
          {useIconButtons ? <LoginIcon /> : t(`header.signup`)}
        </MaterialButtonStyled>
      );
    }
  }

  return undefined;
};

LogoutButton.displayName = 'LogoutButton';

LogoutButton.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(React.memo(withWidget(LogoutButton)));
